import { prerenderReady } from "./prerenderReady";
import { safeCall } from "./safeCall";

export function afterPrerender(
  fn: () => void | Promise<void>,
  entryName: string,
  fnName: string,
): void {
  safeCall(
    async () => {
      await prerenderReady;
      await fn();
    },
    entryName,
    fnName,
  );
}
